import { render, staticRenderFns } from "./NewsSidebar.vue?vue&type=template&id=0c397534&"
import script from "./NewsSidebar.vue?vue&type=script&lang=js&"
export * from "./NewsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NewsSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports